module.exports = __webpack_public_path__ + "static/diy_recipe_tiny_turtles-018b2f59792c2454de7ced38a8feebd5.pdf";